export default __webpack_public_path__ + "static/media/topbar-icon-bell.357e7e00.svg";